<template>
  <div id="share-resource-faq" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto uk-margin-auto-vertical">
      <div uk-grid>
        <div class="uk-width-1-4 uk-flex uk-flex-middle">
          <img class="icon-style" :src="documentApprovedIcon"/>
        </div>
        <div class="uk-width-3-4 info-container">
          <div class="header">
            {{$t('modals.shareResourceFAQ.title')}}
          </div>
          <ul class="uk-list uk-list-bullet info">
            <li>{{$t('modals.shareResourceFAQ.soleCreator')}}</li>
            <li>{{$t('modals.shareResourceFAQ.permissionToShare')}}
            </li>
          </ul>
          <p class="warning">{{$t('modals.shareResourceFAQ.warning')}}</p>
        </div>
      </div>
      <div class="divider"></div>
      <div uk-grid>
        <div class="uk-width-1-4 uk-flex uk-flex-middle">
          <img class="icon-style" :src="fileExchangeIcon"/>
        </div>
        <div class="uk-width-3-4 info-container">
          <div class="header">
            {{$t('modals.shareResourceFAQ.whatCanOthers')}}
          </div>
          <p class="info">{{$t('modals.shareResourceFAQ.usersCanUse')}}</p>
          <p class="info" v-html="$t('modals.shareResourceFAQ.resourcesShared')"></p>
        </div>
      </div>
      <div uk-grid>
        <div class="uk-width-3-5 uk-flex uk-flex-middle">
          <p class="learn-more" v-html="$t('modals.shareResourceFAQ.learnMore')"></p>
        </div>
        <div class="uk-width-2-5 uk-flex uk-flex-right">
          <button class="uk-button cp-primary-button uk-modal-close" type="button"><span class="uk-text-capitalize uk-text-bold">{{$t('general.gotIt')}}</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as misc from '../../../enums/misc'
  import * as url from '../../../enums/static-urls'
  import iconUtil from '../../../utils/icon-util'

  export default {
    name: 'share-resource-faq',
    data() {
      return {
        documentApprovedIcon: iconUtil.resolve(misc.DOCUMENT_APPROVE),
        fileExchangeIcon: iconUtil.resolve(misc.FILE_EXCHANGE),
        termsOfUseUrl: url.RESOURCE_SUBMISSION_TERMS,
        privacyPolicyUrl: url.PRIVACY_POLICY,
        legalCommonsUrl: url.LEGAL_COMMONS
      }
    },
    methods: {
      openUrl(url) {
        window.open(url, '_blank')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../styles/colours';

  a {
    color: $content-link-blue;
    font-weight: bold;
  }

  .divider {
    width: 100%;
    height:3px;
    background-color: $divider;
    margin-top: 36px;
    margin-bottom: 31px;
  }

  .header {
    font-size: 22px;
    font-weight: bold;
    color: $content-text;
  }

  .icon-style {
    padding-left: 12px;
  }

  .info {
    font-size: 14px;
    color: $content-text;
  }

  .info-container {
    padding-left: 0;
  }

  .learn-more {
    font-size: 12px;
    color: $content-text;
  }

  .uk-button {
    width: 170px;
    height: 44px;
  }

  .uk-modal-dialog {
    width: 756px;
  }

  .uk-modal-body {
    padding: 32px 24px 24px 32px;
    line-height: 1.64;
  }

  .warning {
    font-size: 14px;
    font-weight: bold;
    color: $content-text;
  }

</style>
